// src/components/shared/commandColumns.js
// Shared column definitions for FileTransferCommand and ConnectionCommand tables.
// Both feature sets use the same schema — kept here to avoid duplication.

import React from "react";
import SelectEditCell from "./SelectEditCell";

export const commandColumns = [
  {
    accessorKey: "TRANSFER_SEQ",
    header: "Transfer Seq",
    size: 150,
    enableEditing: false,
  },
  {
    id: "PARENT_SEQ",
    accessorKey: "PARENT_SEQ",
    header: "Parent Seq",
    size: 150,
    enableEditing: false,
    enableHiding: true,
  },
  {
    accessorKey: "TRANSFER_NAME",
    header: "Transfer Name",
    size: 150,
  },
  {
    accessorKey: "STATE",
    header: "Status",
    size: 150,
    Edit: ({ cell }) => (
      <SelectEditCell
        cell={cell}
        field="STATE"
        label="Status"
        options={["Active", "Disable"]}
      />
    ),
  },
  {
    accessorKey: "PROJECT_ID",
    header: "Project ID",
    size: 150,
    enableHiding: true,
  },
  {
    accessorKey: "FREQUENCY",
    header: "Frequency",
    size: 150,
    Edit: ({ cell }) => (
      <SelectEditCell
        cell={cell}
        field="FREQUENCY"
        label="Frequency"
        options={["HOURLY", "DAILY", "WEEKLY", "MONTHLY"]}
      />
    ),
  },
  {
    accessorKey: "CMD",
    header: "Command",
    id: "CMD",
    size: 150,
    Edit: ({ cell }) => (
      <SelectEditCell
        cell={cell}
        field="CMD"
        label="Command"
        options={["copy", "move", "convert", "csvsubset", "rename", "rezip", "unzip", "transform"]}
      />
    ),
  },
  {
    accessorKey: "CMD_GROUP",
    header: "Command Group",
    size: 150,
  },
  {
    accessorKey: "SOURCE",
    header: "Source",
    size: 150,
  },
  {
    accessorKey: "DESTINATION",
    header: "Destination",
    size: 150,
  },
  {
    accessorKey: "FILTER",
    header: "Filter",
    size: 150,
  },
  {
    accessorKey: "FROM_PATH",
    header: "From",
    size: 150,
  },
  {
    accessorKey: "TO_PATH",
    header: "To",
    size: 150,
  },
  {
    accessorKey: "ARCHIVE",
    header: "Archive",
    size: 150,
  },
  {
    accessorKey: "FILE_MASK",
    header: "File mask",
    size: 150,
    Edit: ({ cell }) => (
      <SelectEditCell
        cell={cell}
        field="FILE_MASK"
        label="File Mask"
        options={["true", "false"]}
      />
    ),
  },
  {
    accessorKey: "PROCESS",
    header: "Process",
    size: 150,
  },
  {
    accessorKey: "REQUIRED_FL",
    header: "Required flag",
    size: 150,
    Edit: ({ cell }) => (
      <SelectEditCell
        cell={cell}
        field="REQUIRED_FL"
        label="Required flag"
        options={["0", "1"]}
      />
    ),
  },
  {
    accessorKey: "OVERWRITE_FL",
    header: "Overwrite flag",
    size: 150,
    Edit: ({ cell }) => (
      <SelectEditCell
        cell={cell}
        field="OVERWRITE_FL"
        label="Overwrite flag"
        options={["0", "1"]}
      />
    ),
  },
  {
    accessorKey: "SUBFOLDERS_FL",
    header: "Sub Folder Flag",
    size: 150,
    Edit: ({ cell }) => (
      <SelectEditCell
        cell={cell}
        field="SUBFOLDERS_FL"
        label="Sub Folder flag"
        options={["0", "1"]}
      />
    ),
  },
  {
    accessorKey: "LIST_LIMIT",
    header: "List Limit",
    size: 150,
  },
  {
    accessorKey: "LIST_ORDER",
    header: "List Order",
    size: 150,
  },
  {
    accessorKey: "REPLACES",
    header: "Replaces",
    size: 150,
  },
];

/** Fields to strip from raw API response before display */
export const COMMAND_FIELDS_TO_DELETE = [
  "_pkTransferCmd",
  "pkTransferCmd",
  "CREATED_BY",
  "CREATED_TS",
];

/** Explicit field list for mapping API rows to table rows */
export const COMMAND_ROW_FIELDS = [
  "TRANSFER_ID",
  "TRANSFER_SEQ",
  "PARENT_SEQ",
  "TRANSFER_NAME",
  "STATE",
  "PROJECT_ID",
  "FREQUENCY",
  "CMD",
  "CMD_GROUP",
  "SOURCE",
  "DESTINATION",
  "FILTER",
  "FROM_PATH",
  "TO_PATH",
  "ARCHIVE",
  "FILE_MASK",
  "PROCESS",
  "REQUIRED_FL",
  "OVERWRITE_FL",
  "SUBFOLDERS_FL",
  "LIST_LIMIT",
  "LIST_ORDER",
  "REPLACES",
];

/** Strip internal fields and return only display fields from a raw command row */
export function toCommandRow(command) {
  return COMMAND_ROW_FIELDS.reduce((acc, field) => {
    acc[field] = command[field];
    return acc;
  }, {});
}
